import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const ManagerTopBarSearchIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon data-testid="managerTopBar search icon" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1225 16.5856C11.4669 19.5134 6.11579 19.283 2.72702 15.8942C-0.909006 12.2582 -0.909006 6.36304 2.72702 2.72702C6.36304 -0.909006 12.2582 -0.909006 15.8942 2.72702C19.283 6.11578 19.5134 11.4669 16.5856 15.1225L23.697 22.234C24.101 22.638 24.101 23.293 23.697 23.697C23.293 24.101 22.638 24.101 22.234 23.697L15.1225 16.5856ZM4.19004 14.4312C1.36202 11.6032 1.36202 7.01806 4.19004 4.19004C7.01806 1.36202 11.6032 1.36202 14.4312 4.19004C17.2571 7.01599 17.2592 11.5965 14.4374 14.425C14.4353 14.427 14.4333 14.4291 14.4312 14.4312C14.4291 14.4332 14.427 14.4353 14.425 14.4374C11.5965 17.2592 7.01599 17.2572 4.19004 14.4312Z"
      fill="currentColor"
    />
  </Icon>
);
